import type * as Types from '../../sleuth/static/js/spa/types/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetBaseurlQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBaseurlQuery = { __typename?: 'Query', baseurl: string };


export const GetBaseurlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBaseurl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseurl"}}]}}]} as unknown as DocumentNode<GetBaseurlQuery, GetBaseurlQueryVariables>;